import script from "./fw00_options_error.vue?vue&type=script&setup=true&lang=js"
export * from "./fw00_options_error.vue?vue&type=script&setup=true&lang=js"

import "./fw00_options_error.vue?vue&type=style&index=0&id=40a5b75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a5b75c"]])

export default __exports__